
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 405 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M0 0h405v197H0z"}}),_c('g',{attrs:{"opacity":".2"}},[_c('path',{attrs:{"d":"M-136.069 454c0-499.271 404.798-904.069 904.069-904.069 499.27 0 904.07 404.722 904.07 904.069H1743c0-538.482-436.52-975-975-975-538.482 0-975 436.518-975 975h70.931z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M768.001-379.213c-460.136 0-833.137 373.001-833.137 833.137H5.795c0-421.001 341.281-762.282 762.283-762.282S1530.28 32.999 1530.28 454.001h70.93c0-460.137-373-833.137-833.209-833.137v-.077z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M768-237.352C386.21-237.352 76.65 72.208 76.65 454h70.931c0-342.657 277.763-620.42 620.419-620.42 342.66 0 620.42 277.763 620.42 620.42h70.93c0-381.791-309.56-691.352-691.35-691.352z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M768.002-95.564C464.48-95.564 218.437 150.478 218.436 454h70.932c0-264.311 214.323-478.633 478.634-478.633 264.308 0 478.638 214.323 478.638 478.633h70.93c0-303.521-246.05-549.564-549.568-549.564z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M768 46.297c-225.176 0-407.702 182.526-407.702 407.702h70.931c0-186.042 150.806-336.847 336.848-336.847s336.843 150.805 336.843 336.847h70.94c0-225.176-182.53-407.702-407.707-407.702H768z","fill":"#B8C9DE"}})])])
          )
        }
      }
    